"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var UIProps_1 = require("../UIProps");
require("./ToolTip.css");
var classnames_1 = __importDefault(require("classnames"));
var keyboard_1 = require("../../utils/dom/keyboard");
exports.ToolTipRebuild = react_tooltip_1.default.rebuild;
var ToolTipComp = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? 'bottom' : _b, _c = _a.background, background = _c === void 0 ? 'light' : _c, props = __rest(_a, ["placement", "background"]);
    var _d = __read(react_1.useState(true), 2), isHidden = _d[0], setIsHidden = _d[1];
    var onKeyDown = function (e) {
        if (!isHidden && keyboard_1.isKeyEscape(e)) {
            react_tooltip_1.default.hide();
        }
    };
    react_1.useEffect(function () {
        window.addEventListener('keydown', onKeyDown);
        return function () {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [isHidden]);
    return (React.createElement(react_tooltip_1.default, __assign({}, UIProps_1.setUIProps(props), { id: props.id, role: 'tooltip', "aria-hidden": isHidden, className: classnames_1.default('ToolTip', props.className), place: placement, type: background, event: 'mouseover focusin', eventOff: 'mouseout focusout', effect: 'solid', offset: __assign(__assign(__assign(__assign({}, (placement === 'top' ? { top: 10 } : {})), (placement === 'right' ? { right: 10 } : {})), (placement === 'left' ? { left: 10 } : {})), (!placement || placement === 'bottom' ? { bottom: 10 } : {})), afterShow: function () { return setIsHidden(false); }, afterHide: function () { return setIsHidden(true); } }), props.children));
};
exports.ToolTip = React.memo(ToolTipComp);
